export type Currency = "EUR" | "USD";
export const PLAN_KEYS = ["solo", "pro", "business"] as const;
export type PlanKey = (typeof PLAN_KEYS)[number];

export const PLAN_AMOUNTS: Record<PlanKey, Record<Currency, number>> = {
  solo: { EUR: 89, USD: 95 },
  pro: { EUR: 179, USD: 195 },
  business: { EUR: 249, USD: 269 },
};

export const PLAN_PRICES: Record<PlanKey, Record<Currency, string>> = {
  solo: { EUR: "89€", USD: "$95" },
  pro: { EUR: "179€", USD: "$195" },
  business: { EUR: "249€", USD: "$269" },
};

export const USAGE_PRICE_EUR = "0,19€/min";
